// import React from "react";

// const HeroAgents = () => {
//   return (
//     <section className="hero-section">
//       <h1 className="hero-title">Meet Your AI Trading Sidekicks</h1>
//       <p className="hero-subtitle">
//         FinTorro AI Agents help you make smarter decisions faster — whether you’re analyzing charts, testing strategies, or navigating market chaos.
//       </p>
//       <button className="cta-button" onClick={() => window.location.href = "/agent-access"}>Start Using AI Agents</button>
//     </section>
//   );
// };

// export default HeroAgents;



import React from "react";
import heroImage from "../../assets/FinTorro-The-Rise-No-logo-Large.jpeg";
import appStore from "../../assets/appstore-download.svg";
import playStore from "../../assets/playstore-download.png";
import "../../styles/homepage.css";

const HeroAgentsSection = () => {
  return (
    <section id="hero" className="hero">
      <div className="container">
        {/* <img
          src={heroImage}
          alt="Silhouette rising with sun - The Rise"
          className="hero-banner-image"
        /> */}
        <h1>Invest & Trade Smarter With AI Agents</h1>
      
        <p>Learn, analyze & act with confidence — every day.</p>
      
        <div className="hero-cta-group">
          <div className="app-badges">
            <a
              href="https://apps.apple.com/us/app/fintorro-trading-lessons/id6444193731"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img
                src={appStore}
                alt="Download on the App Store"
                className="store-badge"
              />
            </a>
            <a
              href="https://app.fintorro.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img
                src={playStore}
                alt="Get it on Google Play"
                className="store-badge"
              />
            </a>
          </div>
          <a href="/agent-access" className="cta-button">Try AI Agent Now</a>
        </div>
      </div>
    </section>
  );
};

export default HeroAgentsSection;




